<template>
  <div class="main">
    <div class="brand_box">
      <div class="logo">
        <div class="logo_image"></div>
      </div>
      <div class="title">有朋相册 • <span>不亦乐乎</span></div>
      <div class="subtitle">和您的朋友、家人、同学、同事<br>共享影集，分享快乐</div>
    </div>
    <div>
      <input class="field" placeholder="昵称" type="text" v-model.trim="fullName" />
      <input class="field" placeholder="密码" type="password" v-model.trim="password" />
    </div>
    <div class="btn_large" @click="signup">保存</div>
    <div class="btn_box">
      <div class="btn_center">已有账户？<span @click="goToLogin">立即登录</span></div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
export default {
  name: 'Signup',
  data: function () {
    return {
      mobilePhone: '',
      fullName: '',
      password: '',
      smsCode: '',
      smsCodeTime: 0
    }
  },
  methods: {
    async getSmsCode () {
      try {
        if (!this.mobilePhone) {
          return Toast({
            message: '请填写手机号码'
          })
        }
        this.smsCodeTime = 60
        const smsCodeTimer = setInterval(() => {
          this.smsCodeTime -= 1
          if (this.smsCodeTime <= 0) {
            clearInterval(smsCodeTimer)
          }
        }, 1000)
        await this.$faApi.getSmsCode({
          mobilePhone: this.mobilePhone
        })
      } catch (err) {
        this.$faLogger.error('Signup.vue:getSmsCode', err)
      }
    },

    async signup () {
      try {
        if (!this.mobilePhone) return Toast({ message: '请填写手机号码' })
        if (!this.fullName) return Toast({ message: '请填写昵称' })
        if (!this.password) return Toast({ message: '请填写密码' })
        if (!this.smsCode) return Toast({ message: '请填写短信验证码' })
        
        Indicator.open()
        // 注册
        const signupRes = await this.$faApi.signup({
          mobilePhone: this.mobilePhone,
          fullName: this.fullName,
          password: this.password,
          smsCode: this.smsCode
        })
        
        if (signupRes.code === 'INVALID_SMS_CODE') {
          Indicator.close()
          return Toast({ message: '验证码错误' })
        }
        if (signupRes.code === 'MOBILE_PHONE_EXIST') {
          Indicator.close()
          return Toast({ message: '手机号码已注册' })
        }
        
        // 登录
        const loginRes = await this.$faApi.login({
          mobilePhone: this.mobilePhone,
          password: this.password
        })

        if (loginRes.code === 'USER_NOT_EXIST') { 
          Indicator.close()
          return Toast({ message: '用户不存在' }) 
        }
        if (loginRes.code === 'INVALID_PASSWORD') { 
          Indicator.close()
          return Toast({ message: '密码错误' }) 
        }

        // 登录后保存accessToken
        localStorage.setItem(this.$faStorage.keys.accessToken, loginRes.accessToken)

        // 加入群
        const inviteCode = localStorage.getItem(this.$faStorage.keys.inviteCode)
        const groupId = localStorage.getItem(this.$faStorage.keys.inviteGroupId)
        if (inviteCode && groupId) {
          const joinGroupRes = await this.$faApi.joinGroupWithInviteCode(inviteCode, groupId)
          if (joinGroupRes.code === 'INVALID_INVITE_CODE') {
            Indicator.close()
            return Toast({ message: '无效邀请码' })
          }
          localStorage.removeItem(this.$faStorage.keys.inviteCode)
          localStorage.removeItem(this.$faStorage.keys.inviteGroupId)
          Indicator.close()
          return this.$router.push({ path: `/group/${groupId}` })
        }
        
        Indicator.close()
        const loginRedirectUrl = localStorage.getItem(this.$faStorage.keys.loginRedirectUrl)
        if (loginRedirectUrl) {
          localStorage.removeItem(this.$faStorage.keys.loginRedirectUrl)
          this.$router.push({ path: loginRedirectUrl })
        } else {
          this.$router.push({ path: `/user/${loginRes.userId}/joined_groups` })
        }
      } catch (err) {
        this.$faLogger.error('Signup.vue:signup', err)
      }
    },
    goToLogin() {
      this.$router.push({ path: '/login_sms' })
    }
  }
}
</script>

<style scoped lang="scss">
  .main {
    margin: 0 auto;
    padding: 16px;
    max-width: 320px;
  }
  .brand_box {
    margin-bottom: 48px;
    position: relative;
    text-align: center;
    .title {
      margin: 0;
      font-size: 30px;
      font-weight: bold;
      span {
        font-weight: bold;
      }
    }
    .subtitle {
      margin: 0;
      font-size: 18px;
      font-weight: 300;
      color: black;
    }
    .logo {
      position: relative;
      margin: 16px auto;
      width: 160px;
      height: 160px;
    }
    .logo_image {
      position: relative;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url('../assets/logo_960.png');
    }
  }
  .field_box {
    position: relative;
  }
  .field {
    margin: 8px 0 0 0;
    width: 100%;
    height: 40px;
    border-width: 0 0 1px 0;
    border-radius: 0;
    border-bottom: 1px solid #e0e0e0;
    background-color: #fff8;
    text-align: left;
    font-size: 16px;
    font-weight: 300;
  }
  .btn_small {
    position: absolute;
    top: 12px;
    right: 0;
    margin: 0;
    padding: 0 4px;
    width: 80px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 4px;
    text-align: center;
    color: white;
    background-color: red;
    z-index: 999;
    cursor: pointer;
  }
  .btn_large {
    margin: 24px auto 16px auto;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 900;
    text-align: center;
    color: white;
    background-color: red;
    cursor: pointer;
  }
  .btn_box {
    position: relative;
    width: auto;
    height: 32px;
  }
  .btn_center {
    position: relative;
    width: auto;
    padding: 0 8px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    font-weight: normal;
    text-align: center;
    color: darkgray;
    span {
      font-weight: bold;
      color: red;
      cursor: pointer;
    }
  }
</style>
